import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { InputSwitch } from "primereact/inputswitch";
import { getProduct, updateProduct } from "../../Services/ProductService";
import { useSelector } from "react-redux";
import { getLanguages } from "../../Services/LanguageService";
import ModalFormFeature from "../../Components/Product/Modal/ModalFormFeature";
import {
  getAppList,
  getImageFunc,
  getVideoFunc,
} from "../../Services/AppService";
import { getSeriesAll } from "../../Services/SeriesService";
import { getSeupplier } from "../../Services/SAPService";
import Swal from "sweetalert2";
import Overlay from "../../Components/Overlay/Overlay";
import SkuEdit from "../../Components/Product/SkuEdit";
import Common from "../../Constants/Common";
import { toastError } from "../../Components/Toasts/Toast";
import InputAutoComplete from "../../Components/Autocomplete/InputAutoComplete";
import bwipjs from "bwip-js";
import {
  getFeatureBySubCategory,
  getFeatureMappingBySubCat,
} from "../../Services/FeatureService";
import ProductDimension from "../../Components/Product/FileHandler/ProductDimension";
import { getIotSeriesAll } from "../../Services/IoTSeriesService";
import { getSubSubcategoryAll } from "../../Services/SubSubcategoryService";

const wrapStyle = {
  width: 130,
  height: 100,
  borderRadius: 4,
  marginRight: 16,
  marginBottom: 16,
  position: "relative",
  border: "solid 1px #ccc",
  borderRadius: 6,
};
let processingId = -1;
const { $ } = window;
const modalId = "#product-edit-modal";
const modalId2 = "#product-edit-video";
const modalId3 = "#product-edit-video-desc";
const modalId10 = "#product-create-feature-score";

const ProductDetailEditPage = () => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  let { userInfo } = useSelector((state) => state.auth);
  const { item_code } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      model_code: "",
      item_name: "",
      item_code_original: "",
      group_code: "",
      height: 0,
      width: 0,
      length: 0,
      depth: 0,
      weight: 0,
      volume: 0,
      outer_height: 0,
      outer_width: 0,
      outer_length: 0,
      outer_depth: 0,
      outer_weight: 0,
      cut_out_height: 0,
      cut_out_width: 0,
      cut_out_length: 0,
      cut_out_depth: 0,
      cut_out_height_topmount: 0,
      cut_out_width_topmount: 0,
      cut_out_length_topmount: 0,
      cut_out_height_undermount: 0,
      cut_out_width_undermount: 0,
      cut_out_length_undermount: 0,
      weight_type: "",
      scale: "",
      launch_date: "",
      cardcode: "",
      barcode_sni: "",
      barcode_qr: "",
      is_active: true,
      is_publish_web: false,
      is_manage_serial: false,
      numRows: 1,
      numRowsUps: 1,
      product_class: "",
    },
  });

  const [state, setState] = useState({
    is_creation_approved: false,
    countryCode: "",
    itemCode: "",
    canvasUrl: [],
    countryChange: "",
    selectedSupplierCode: "",
    suppliers: [],
    files: [],
    manualBooksDelete: [],
    manualBooks: [],
    filesDescs: [],
    videoDescs: [],
    fileSelected: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    filesNew: [],
    filesDescsNew: [],
    fileSelectedNew: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    videoSelected: "",
    video_types: [],
    media_types: [],
    content_types: [],
    product: [],
    selectedLang: {
      language_code: "",
      language_name: "",
    },
    productDetails: [],
    incident_id: null,
    incident_status: null,
    next_step_nik: null,
    next_step_name: null,
    languages: [],
    productDetail: {
      language_code: "",
      language_name: "",
      title: "",
      header_description: "",
      description: "",
      feature: "",
      including: "",
      tagline: "",
      price: 0,
      manual_book: null,
      is_preorder: 0,
      is_rental: 0,
      is_active: true,
      is_publish_web: false,
      is_me_by_modena: 0,
      sku_me_by_modena: "",
      sticker_price: 0,
    },
    productHighlights: [],
    productHighlight: [
      {
        language_code: "",
        language_name: "",
        title: "",
        description: "",
      },
    ],
    productUpss: [],
    productUps: [
      {
        name: "",
        media_code: "",
        media_type: [],
        media_desc: "",
        content_type: [],
        file_path: "",
        tags: [],
      },
    ],
    filesUps: [],
    filesDescsUps: [],
    filesDescsUpss: [],
    fileSelectedUps: {
      fileName: "",
      media_desc: "",
      language_code: "",
      line_num: "",
      media_types: [],
      content_types: [],
    },
    deletedFile: [],
    deletedDetail: [],
    deletedFileNew: [],
    deletedFileUps: [],
    deletedHighlight: [],
    deletedUps: [],
    deletedUpsTag: [],
    deletedVideo: [],
    deletedEcom: [],
    videoUrl: "",
    videoLang: "",
    processing: false,
    numRows: 1,
    numRowsUps: 1,
    reqFeature: [],
    feature_update: [],
    totScoreFeature: 0,
    activeTab: "tab1",
    productEcom: [],
    sub_sub_category: {},
    org_id_sub_sub_category: 0,
  });

  useEffect(() => {
    if (getValues("id_sub_category") && getValues("id_sub_category") > 0) {
      getSubSubcategoryAll({
        filter: `id_sub_category:${getValues("id_sub_category")}`,
      }).then((res) => {
        if (
          res.status == 200 &&
          (!sub_sub_category || Object.keys(sub_sub_category).length === 0)
        ) {
          setState({
            ...state,
            sub_sub_category: res.data,
          });
        }
      });
    }
  }, [getValues("id_sub_category")]);

  const onSetSupplierCode = (e) => {
    setState({ ...state, selectedSupplierCode: e.target.value });
  };

  const onClickSupplier = (value) => {
    setValue("cardcode", value);
    setState({ ...state, suppliers: [], selectedItemCode: value });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onFormVideo = () => {
    $(modalId2).modal("show");
  };

  const onFormVideoChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const onSaveVideo = () => {
    const indexVideo = videoDescs.findIndex((e) => e.fileName == videoUrl);
    if (indexVideo > -1) {
      toastError("Video URL already exists!");
      return;
    }

    const indexLang = languages.findIndex((e) => e.language_code == videoLang);
    if (indexLang > -1) {
      videoDescs.push({
        filePath: Common.ytEmbedUrl,
        fileName: videoUrl,
        language_code: videoLang,
        language_name: JSON.parse(
          JSON.stringify(languages[indexLang].language_name)
        ),
        media_types: [],
        content_types: [],
      });
      setState({ ...state, videoDescs, videoUrl: "", videoLang: "" });
      $(modalId2).modal("hide");
    } else {
      toastError("Failed video, please try againt!");
    }
  };

  const onFileChange = (e) => {
    const _files = [...files, ...e.target.files];
    setState({ ...state, files: _files });
  };

  const onAddFileDesc = (file) => {
    setState({ ...state, fileSelected: {} });
    const fileName = file.url ? file.fileName : file.name.split(" ").join("");
    if (filesDescs[fileName]) {
      setState({ ...state, fileSelected: filesDescs[fileName] });
    } else {
      filesDescs[fileName] = {
        fileName,
        media_desc: "",
        media_types: [],
        content_types: [],
      };
      setState({ ...state, filesDescs, fileSelected: filesDescs[fileName] });
    }

    setTimeout(() => {
      $(modalId).modal("show");
    }, 150);
  };

  const onDescChange = (e) => {
    filesDescs[fileSelected.fileName].media_desc = e.target.value;
    const _fileSelected = { ...fileSelected, media_desc: e.target.value };
    setState({ ...state, filesDescs, fileSelected: _fileSelected });
  };

  const onRemoveFile = (file, i) => () => {
    if (file.url) {
      deletedFile.push(file.fileName);
    }

    files.splice(i, 1);
    setState({ ...state, files, deletedFile });
  };

  const REVISE = 2;
  const APPROVE = 1;
  const REJECT = 3;

  const onAddFileDescModal = (type, position) => {
    const index =
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.indexOf(type)
        : filesDescs[fileSelected.fileName].content_types.indexOf(type);

    if (index > -1) {
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.splice(index, 1)
        : filesDescs[fileSelected.fileName].content_types.splice(index, 1);
    } else {
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.push(type)
        : filesDescs[fileSelected.fileName].content_types.push(type);
    }

    setState({ ...state, filesDescs });
  };

  const onAddVideoDesc = (video) => {
    const videoIndex = videoDescs.findIndex(
      (e) => e.fileName == video.fileName
    );
    setState({ ...state, videoSelected: videoIndex });
    setTimeout(() => {
      $(modalId3).modal("show");
    }, 150);
  };

  const onAddVideoDescModal = (type, position) => {
    const index =
      position == "media_types"
        ? videoDescs[videoSelected].media_types.indexOf(type)
        : videoDescs[videoSelected].content_types.indexOf(type);

    if (index > -1) {
      position == "media_types"
        ? videoDescs[videoSelected].media_types.splice(index, 1)
        : videoDescs[videoSelected].content_types.splice(index, 1);
    } else {
      position == "media_types"
        ? videoDescs[videoSelected].media_types.push(type)
        : videoDescs[videoSelected].content_types.push(type);
    }
    setState({ ...state, videoDescs });
  };

  const onRemoveVideo = (i) => () => {
    if (videoDescs[i].id) {
      deletedVideo.push(videoDescs[i].id);
      videoDescs.splice(i, 1);
      setState({ ...state, videoDescs, deletedVideo });
    } else {
      videoDescs.splice(i, 1);
      setState({ ...state, videoDescs });
    }
  };

  const onAddFeatureModal = (a) => {
    setTimeout(() => {
      $(modalId10).modal("show");
    }, 150);
  };

  const genModelCode = (product) => {
    if (product.item_code_array) {
      const sku = product.item_code_array;
      const modelCode = `${sku[0]}${sku[1]} ${sku[2]}${sku[3]}${sku[4]}${sku[5]} ${sku[6]}${sku[7]}${sku[8]}${sku[9]}`;
      setValue("model_code", modelCode);
    }
  };

  const onSubSubChange = (e) => {
    const _sub_sub_category = subsubcategories.find(
      (item) => item.id == e.target.value
    );
    if (e.target.value == org_id_sub_sub_category) {
      getFeatureMappingBySubCat(
        product.item_code,
        org_id_sub_sub_category,
        ({ data }) => {
          setState((prev) => {
            return {
              ...prev,
              id_sub_sub_category: e.target.value,
              sub_sub_category: _sub_sub_category,
              reqFeature: data.productFeature,
              totScoreFeature: data.totScoreFeature,
            };
          });
          setTimeout(() => {
            setValue("product_class", product.product_class);
          }, 100);
        },
        (error) => { }
      );
    } else {
      getFeatureBySubCategory(
        _sub_sub_category.id,
        ({ data }) => {
          setState((prev) => {
            return {
              ...prev,
              id_sub_sub_category: e.target.value,
              sub_sub_category: _sub_sub_category,
              reqFeature: data,
              totScoreFeature: 0,
            };
          });
          setTimeout(() => {
            setValue("product_class", "");
          }, 100);
        },
        (error) => { }
      );
    }
  };

  const onApprovalAction = (selected_action, data) => {
    for (let key in data) {
      if (getValues(key) !== undefined) {
        data[key] = getValues(key);
      }
    }
    setState({ ...state, processing: true });
    Swal.fire({
      title:
        "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
      input: "textarea", // Specify the input type as "textarea"
      inputPlaceholder: "Approval remark here",
      allowOutsideClick: false,
      inputAttributes: {
        rows: 4, // Number of rows for the textarea
        required: true,
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work
    }).then((result) => {
      if (result.isConfirmed) {
        // The user confirmed, and you can access the textarea value
        const textarea_value = result.value;
        data.is_draft = false;
        data.selected_action = selected_action;
        data.approval_remark = textarea_value;
        data.assembly = data.assembly;
        const formData = new FormData();
        for (var key in data) {
          formData.append(key, data[key]);
        }
        updateProduct(product.item_code, formData)
          .then((res) => {
            if (res.data.status == 201) {
              Swal.fire({
                icon: "success",
                title: "Save data success",
                text: "Data has been saved!",
              }).then((r) => navigate(-1));
            } else {
              Swal.fire({
                icon: "error",
                title: "Save data failed",
                text: "There's an issue with the system. Please contact IT Support for assistance!",
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Save data failed",
              text: "There's an issue with the system. Please contact IT Support for assistance!",
            });
          });
      } else {
        setState({ ...state, processing: false });
      }
    });
  };

  const onSubmit = (data) => {
    const selected_series = pseries.filter((item) => item.id == data.id_series);
    data["series_name"] = selected_series[0].series_name;
    data["is_draft"] = "false";
    data["sub_sub_category_name"] = sub_sub_category.sub_sub_category_name;
    if (parseFloat(data.length) > 0 && parseFloat(data.depth) > 0) {
      toastError("Please set value to 0 for Length or Depth");
      return;
    }

    if (data.length == 0 && data.depth == 0) {
      setError("length", { type: "min", message: "must be > 0" });
      setError("depth", { type: "min", message: "must be > 0" });
      return;
    } else {
      clearErrors(["length", "depth"]);
    }

    if (data.outer_length == 0 && data.outer_depth == 0) {
      setError("outer_length", { type: "min", message: "must be > 0" });
      setError("outer_depth", { type: "min", message: "must be > 0" });
      return;
    } else {
      clearErrors(["outer_length", "outer_depth"]);
    }

    if (data.is_manage_serial && data.barcode_qr == "") {
      setError("barcode_qr", {
        type: "required",
        message: "Serial Number is required!",
      });
      return;
    } else {
      clearErrors("barcode_qr");
    }

    if (data.launch_date && data.launch_date == "") {
      setError("launch_date", {
        type: "required",
        message: "Launch Date is required!",
      });
      return;
    } else {
      clearErrors("launch_date");
    }

    const formData = new FormData();

    data["item_code"] = product.item_code;
    data["country_code"] = countryChange;

    for (var key in data) {
      formData.append(key, data[key]);
    }

    let m_image_errors = 0;
    let c_image_errors = 0;
    let d_image_errors = 0;
    if (!data.filesDescs) {
      data.filesDescs = {};
    }
    for (let f in filesDescs) {
      if (!data.filesDescs[f]) {
        data.filesDescs[f] = {};
      }
      data.filesDescs[f].fileName = filesDescs[f].fileName;
      data.filesDescs[f].media_desc = filesDescs[f].media_desc;
      data.filesDescs[f].media_type = filesDescs[f].media_types;
      data.filesDescs[f].content_type = filesDescs[f].content_types;

      if (filesDescs[f].skip) {
        data.filesDescs[f].skip = filesDescs[f].skip;
      }

      if (filesDescs[f].media_types.length == 0) {
        m_image_errors++;
      }

      if (filesDescs[f].content_types.length == 0) {
        c_image_errors++;
      }
      if (filesDescs[f].media_desc == "") {
        d_image_errors++;
      }
    }

    if (filesNew.length > 0) {
      if (Object.keys(filesDescsNew).length > 0) {
        for (let c in filesDescsNew) {
          data.filesDescsNew[c].fileName = filesDescsNew[c].fileName;
          data.filesDescsNew[c].media_desc = filesDescsNew[c].media_desc;
          data.filesDescsNew[c].media_type = filesDescsNew[c].media_types;
          data.filesDescsNew[c].content_type = filesDescsNew[c].content_types;

          if (filesDescsNew[c].skip) {
            data[`filesDescsNew[${c}][skip]`] = filesDescsNew[c].skip;
          }

          if (filesDescsNew[c].media_types.length == 0) {
            m_image_errors++;
          }

          if (filesDescsNew[c].content_types.length == 0) {
            c_image_errors++;
          }

          if (filesDescsNew[c].media_desc == "") {
            d_image_errors++;
          }
        }
      } else {
        toastError(
          "Please fill description image product highlight before submit!"
        );
        return;
      }
    }

    for (let i in files) {
      if (!files[i].url) {
        if (!filesDescs[files[i].name.split(" ").join("")]) {
          m_image_errors++;
        } else {
          if (
            filesDescs[files[i].name.split(" ").join("")].media_types.length ==
            0
          ) {
            m_image_errors++;
          }
        }

        if (!filesDescs[files[i].name.split(" ").join("")]) {
          c_image_errors++;
        } else {
          if (
            filesDescs[files[i].name.split(" ").join("")].content_types
              .length == 0
          ) {
            c_image_errors++;
          }
        }

        if (!filesDescs[files[i].name.split(" ").join("")]) {
          d_image_errors++;
        } else {
          if (!filesDescs[files[i].name.split(" ").join("")].media_desc) {
            d_image_errors++;
          }
        }

        data[`images[${i}]`] = files[i];
      }
    }

    for (let i in filesNew) {
      if (!filesNew[i].url) {
        // if (!filesDescsNew[filesNew[i].name.split(" ").join("")]) {
        //     m_image_errors++;
        // } else {
        //     if (filesDescsNew[filesNew[i].name.split(" ").join("")].media_types.length == 0) {
        //         m_image_errors++;
        //     }
        // }

        // if (!filesDescsNew[filesNew[i].name.split(" ").join("")]) {
        //     c_image_errors++;
        // } else {
        //     if (filesDescsNew[filesNew[i].name.split(" ").join("")].content_types.length == 0) {
        //         c_image_errors++;
        //     }
        // }

        // if (!filesDescsNew[filesNew[i].name.split(" ").join("")]) {
        //     d_image_errors++;
        // } else {
        //     if (!filesDescsNew[filesNew[i].name.split(" ").join("")].media_desc) {
        //         d_image_errors++;
        //     }
        // }

        data.imagesHighlight[i] = filesNew[i];
      }
    }

    for (let i in filesUps) {
      if (filesUps[i] != undefined) {
        // if (!filesDescsNew[filesNew[i].name.split(" ").join("")]) {
        //     m_image_errors++;
        // } else {
        //     if (filesDescsNew[filesNew[i].name.split(" ").join("")].media_types.length == 0) {
        //         m_image_errors++;
        //     }
        // }

        // if (!filesDescsNew[filesNew[i].name.split(" ").join("")]) {
        //     c_image_errors++;
        // } else {
        //     if (filesDescsNew[filesNew[i].name.split(" ").join("")].content_types.length == 0) {
        //         c_image_errors++;
        //     }
        // }

        // if (!filesDescsNew[filesNew[i].name.split(" ").join("")]) {
        //     d_image_errors++;
        // } else {
        //     if (!filesDescsNew[filesNew[i].name.split(" ").join("")].media_desc) {
        //         d_image_errors++;
        //     }
        // }

        data.imagesUsp[i] = filesUps[i];
      }
    }

    for (let ii in productUps) {
      if (filesUps.length > 0) {
        if (productUps[ii].media_type.length == 0) {
          m_image_errors++;
        }

        if (productUps[ii].content_type == 0) {
          c_image_errors++;
        }
      }
    }

    for (let i in manualBooks) {
      data.manual_books[i] = manualBooks[i][0];
    }

    for (let i in manualBooksDelete) {
      data.manual_books_delete[i] = manualBooksDelete[i];
    }

    if (m_image_errors > 0) {
      toastError("Please complete all image functionality!");
      return;
    }

    if (c_image_errors > 0) {
      toastError("Please complete app name that using the image!");
      return;
    }

    if (d_image_errors > 0) {
      toastError("Please complete all image description!");
      return;
    }

    // if (productDetail.language_code != '') {
    //     for (const key in productDetail) {
    //         if (productDetail[key] == '' && key != 'is_active' && key != 'is_preorder' && key != 'is_rental' && key != 'manual_book') {
    //             toastError('Please save draft product detail before submit!')
    //             return;
    //         }
    //     }
    // }

    for (let yt in productUps) {
      let dataDescUps = productUps[yt];
      let dataTags = productUps[yt].tags;

      if (dataDescUps.file_path == "" && dataTags.length > 0) {
        toastError(
          "Please upload the image for product usp highlight before submit!"
        );
        return;
      }

      if (dataDescUps.file_path != "") {
        if (dataTags) {
          for (let ee in dataTags) {
            if (dataTags[ee].title == "" || dataTags[ee].description == "") {
              toastError(
                "Please fill title and description product usp highlight before submit!"
              );
              return;
            }
          }
        } else {
          toastError(
            "Please fill title and description product usp highlight before submit!"
          );
          return;
        }
      }
    }

    let xx = 0;
    for (let pd in productDetails) {
      if (
        productDetails[xx].title == "" ||
        productDetails[xx].description == "" ||
        productDetails[xx].header_description == "" ||
        productDetails[xx].tagline == "" ||
        productDetails[xx].id_color == "" ||
        productDetails[xx].id_tag == ""
      ) {
        toastError("Please save product detail before submit!");
        return;
      }
      xx++;
    }

    for (const key in productHighlights) {
      if (
        productHighlights[key].title == "" ||
        productHighlights[key].description == ""
      ) {
        toastError(
          "Please fill title and description product highlight before submit!"
        );
        return;
      }
    }
    if (!data.productDetails) {
      data.productDetails = [];
    }

    let i = 0;

    for (let pd in productDetails) {
      if (!data.productDetails[i]) {
        data.productDetails[i] = {};
      }
      data.productDetails[i].id = productDetails[pd].id;
      if (productDetails[pd].item_code != "") {
        data.productDetails[i].item_code = productDetails[pd].item_code;
      }
      data.productDetails[i].language_code = productDetails[pd].language_code;
      data.productDetails[i].title = productDetails[pd].title;
      data.productDetails[i].header_description =
        productDetails[pd].header_description;
      data.productDetails[i].description = productDetails[pd].description;
      data.productDetails[i].feature = productDetails[pd].feature;
      data.productDetails[i].including = productDetails[pd].including;
      data.productDetails[i].tagline = productDetails[pd].tagline;
      data.productDetails[i].price =
        productDetails[pd].price == "" ? 0 : productDetails[pd].price;
      data.productDetails[i].id_color = productDetails[pd].id_color;
      data.productDetails[i].id_tag = productDetails[pd].id_tag;
      data.productDetails[i].manual_book = productDetails[pd].manual_book;
      data.productDetails[i].is_me_by_modena = productDetails[pd]
        .is_me_by_modena
        ? 1
        : 0;
      data.productDetails[i].is_preorder = productDetails[pd].is_preorder
        ? 1
        : 0;
      data.productDetails[i].is_rental = productDetails[pd].is_rental ? 1 : 0;
      data.productDetails[i].is_active = productDetails[pd].is_active;
      data.productDetails[i].is_publish_web = productDetails[pd].is_publish_web;
      data.productDetails[i].sku_me_by_modena =
        productDetails[pd].sku_me_by_modena;
      data.productDetails[i].sticker_price = productDetails[pd].sticker_price;
      data.productDetails[i].seo_title = productDetails[pd].seo_title;
      data.productDetails[i].seo_description =
        productDetails[pd].seo_description;
      data.productDetails[i].url_ar = productDetails[pd].url_ar;
      i++;
    }

    for (let pdh in productHighlights) {
      let dataHighlight = productHighlights[pdh];
      if (
        productHighlights[pdh].title != "" &&
        productHighlights[pdh].description != ""
      ) {
        for (let pdhD in dataHighlight) {
          data[productHighlights][pdh][pdhD] = productHighlights[pdh][pdhD];
        }
      }
    }

    // let s = 0;
    // for (let pdh in productUpss) {
    //     let dataUps = productUpss[pdh].data
    //     for (let pduD in dataUps) {
    //         for (let index in dataUps[pduD]) {
    //             formData.append(`productUpss[${s}][${index}]`, dataUps[pduD][index]);
    //         }
    //         s++;
    //     }
    // }

    for (let ft in feature_update) {
      let dataFeature = feature_update[ft];
      if (feature_update[ft].score > 0) {
        for (let fD in dataFeature) {
          data.feature_type[ft][fD] = feature_update[ft][fD];
        }
      } else {
        toastError("Please fill all score feature type!");
        return;
      }
    }

    for (let ii in productUps) {
      let dataDescUps = productUps[ii];
      let dataTags = productUps[ii].tags;
      if (
        productUps[ii].file_path != "" &&
        productUps[ii].file_path != undefined
      ) {
        for (let index in dataDescUps) {
          if (index != "tags") {
            data.productUps[ii][index] = dataDescUps[index];
          }
        }
        for (let ee in dataTags) {
          for (let tag in dataTags[ee]) {
            data.productUps[ii].tags[ee][tag] = dataTags[ee][tag];
          }
        }
      }
    }

    for (let eco in productEcom) {
      let dataEco = productEcom[eco];
      if (
        productEcom[eco].id_store != "" &&
        productEcom[eco].url != "" &&
        productEcom[eco].price != "" &&
        productEcom[eco].id_store != null &&
        productEcom[eco].url != null &&
        productEcom[eco].price != null
      ) {
        for (let ec in dataEco) {
          data[productEcom][eco][ec] = productEcom[eco][ec];
        }
      } else {
        toastError("Please fill all ecommerce data before submit!");
        return;
      }
    }

    let x = 0;
    for (let dd in deletedDetail) {
      data[deletedDetail][x][item_code] = deletedDetail[dd].itemCode;
      data.deletedDetail[x].country_code = deletedDetail[dd].countryCode;
      data.deletedDetail[x].language_code = deletedDetail[dd].languageCode;
      x++;
    }

    let z = 0;
    for (let zz in deletedHighlight) {
      data.deletedHighlight[z].language_code =
        deletedHighlight[zz].language_code;
      data.deletedHighlight[z].line_num = deletedHighlight[zz].line_num;
      data.deletedHighlight[z].id = deletedHighlight[zz].id;
      z++;
    }

    if (!data.deletedUps) {
      data.deletedUps = [];
    }

    let u = 0;
    for (let uu in deletedUps) {
      data.deletedUps[u].item_code = deletedUps[uu].item_code;
      data.deletedUps[u].id = deletedUps[uu].id;
      u++;
    }

    if (!data.deletedUpsTag) {
      data.deletedUpsTag = [];
    }

    let w = 0;
    for (let ww in deletedUpsTag) {
      if (!data.deletedUpsTag[w]) {
        data.deletedUpsTag[w] = {};
      }
      data.deletedUpsTag[w].item_code = deletedUpsTag[ww].item_code;
      data.deletedUpsTag[w].language_code = deletedUpsTag[ww].language_code;
      data.deletedUpsTag[w].country_code = deletedUpsTag[ww].country_code;
      w++;
    }

    if (!data.deletedEcom) {
      data.deletedEcom = [];
    }

    let e = 0;
    for (let ee in deletedEcom) {
      if (!data.deletedEcom[e]) {
        data.deletedEcom[e] = {};
      }
      data.deletedEcom[e].id = deletedEcom[ee].id;
      data.deletedEcom[e].id_store = deletedEcom[ee].id_store;
      data.deletedEcom[e].url = deletedEcom[ee].url;
      data.deletedEcom[e].price = deletedEcom[ee].price;
      e++;
    }

    if (!data.videoDescs) {
      data.videoDescs = [];
    }

    let c_video_errors = 0;
    for (let v in videoDescs) {
      if (!data.videoDescs[v]) {
        data.videoDescs[v] = {};
      }
      if (videoDescs[v].filePath) {
        data.videoDescs[v].id = videoDescs[v].id;
      }
      data.videoDescs[v].file_path = videoDescs[v].filePath;
      data.videoDescs[v].file_name = videoDescs[v].fileName;
      data.videoDescs[v].language_code = videoDescs[v].language_code;
      data.videoDescs[v].media_type = videoDescs[v].media_types;
      data.videoDescs[v].content_type = videoDescs[v].content_types;

      if (videoDescs[v].content_types == 0) {
        c_video_errors++;
      }
    }

    if (c_video_errors > 0) {
      toastError("Please complete app name that using the video!");
      return;
    }

    for (let i in deletedFile) {
      data.deletedFile[i] = deletedFile[i];
    }

    for (let i in deletedFileNew) {
      data.deletedFileNew[i] = deletedFileNew[i];
    }

    for (let i in deletedFileUps) {
      data.deletedFileUps[i] = deletedFileUps[i];
    }

    for (let i in deletedVideo) {
      data.deletedVideo[i] = deletedVideo[i];
    }
    // for (var pair of formData.entries()) {
    //     console.log(pair[0] + ', ' + pair[1]);
    // }

    /*if (deletedFile.length > 0 || deletedVideo.length > 0) {
      Swal.fire({
        icon: "question",
        title: "Are you sure?",
        text: `There is ${deletedFile.length} image & ${deletedVideo.length} video will be delete, you can't restore it after press OK button!`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          const response = updateProduct(product.item_code, formData);
          startProcessing();
          response
            .then((res) => {
              if (res.status == 200 || res.status == 201) {
                Swal.fire({
                  icon: "success",
                  title: "Save data success",
                  text: "Data has been saved!",
                }).then((r) => navigate("/product"));
              }
            })
            .catch(({ response: { data } }) => {
              handlerFormError(data);
            })
            .finally((_) => stopProcessing());
        }
      });
    }else {*/
    Swal.fire({
      title:
        "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
      input: "textarea", // Specify the input type as "textarea"
      inputPlaceholder: "Approval remark here",
      allowOutsideClick: false,
      inputAttributes: {
        rows: 4, // Number of rows for the textarea
        required: true,
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work
    }).then((result) => {
      if (result.isConfirmed) {
        // The user confirmed, and you can access the textarea value
        const textarea_value = result.value;

        formData.append("incident_id", product.incident_id || "0");
        formData.append("incident_status", product.incident_status);
        formData.append("next_step_nik", product.next_step_nik);
        formData.append("next_step_name", product.next_step_name);
        formData.append(
          "incident_id_detail",
          product.incident_id_detail || "0"
        );
        formData.append(
          "incident_status_detail",
          product.incident_status_detail
        );
        formData.append("next_step_nik_detail", product.next_step_nik_detail);
        formData.append("next_step_name_detail", product.next_step_name_detail);
        formData.append("approval_remark", textarea_value);
        formData.append(
          "detail_approval_remark",
          product.detail_approval_remark
        );
        updateProduct(product.item_code, formData)
          .then((res) => {
            if (res.data.status == 201) {
              Swal.fire({
                icon: "success",
                title: "Save data success",
                text: "Data has been saved!",
              }).then((r) => navigate("/product"));
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Save data failed",
              text: "There's an issue with the system. Please contact IT Support for assistance!",
            });
          });
      }
    });
    /*const response = updateProduct(product.item_code, formData);
      startProcessing();
      response
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            Swal.fire({
              icon: "success",
              title: "Save data success",
              text: "Data has been saved!",
            }).then((r) => onBack());
          }
        })
        .catch(({ response: { data } }) => {
          handlerFormError(data);
        })
        .finally((_) => stopProcessing());*/
    //}
  };

  useEffect(() => {
    if (!userInfo.access?.master_product?.can_update) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "You're not allowed to access that page!",
      }).then(() => navigate("/"));
    }
    const reqVideoType = getVideoFunc({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqMediaType = getImageFunc({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqContentType = getAppList({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqProduct = getProduct(item_code, "master").then((res) => res.data);
    const reqLanguage = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqSeries = getSeriesAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqIotSeries = getIotSeriesAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    Promise.all([
      reqVideoType,
      reqMediaType,
      reqContentType,
      reqProduct,
      reqLanguage,
      reqSeries,
      reqIotSeries,
    ]).then((results) => {
      const [
        _video_types,
        _media_types,
        _content_types,
        _product,
        _languages,
        _pseries,
        _iotseries,
      ] = results;
      if (
        !_product?.product?.is_creation_approved &&
        _product?.product?.next_step_nik != userInfo?.nik
      ) {
        if (_product?.product?.incident_status != "REJECTED") {
          Swal.fire({
            title: "Not Allowed!",
            text: "This product is not approved yet. Please wait for approval of the product first!",
            icon: "error",
          }).then((r) => navigate("/product"));
        }
      }
      for (const key in _product.filesDescs[0]) {
        filesDescs[key] = {
          fileName: _product.filesDescs[0][key].fileName,
          media_desc: _product.filesDescs[0][key].media_desc,
          media_types: _product.filesDescs[0][key].media_types,
          content_types: _product.filesDescs[0][key].content_types,
          skip: _product.filesDescs[0][key].skip,
        };
      }

      for (const key in _product.filesDescsNew[0]) {
        filesDescsNew[key] = {
          fileName: _product.filesDescsNew[0][key].fileName,
          media_desc: _product.filesDescsNew[0][key].media_desc,
          media_types: _product.filesDescsNew[0][key].media_types,
          content_types: _product.filesDescsNew[0][key].content_types,
          skip: _product.filesDescsNew[0][key].skip,
        };
      }

      // for (const key in _product.filesDescsUps[0]) {
      //     filesDescsUps[key] = {
      //         fileNameUps: _product.filesDescsUps[0][key].fileName,
      //         media_desc: _product.filesDescsUps[0][key].media_desc,
      //         media_types: _product.filesDescsUps[0][key].media_types,
      //         language_code: _product.filesDescsUps[0][key].language_code,
      //         line_num: _product.filesDescsUps[0][key].line_num,
      //         content_types: _product.filesDescsUps[0][key].content_types,
      //         skip: _product.filesDescsUps[0][key].skip,
      //     }
      // }

      for (const key in _product.videoDescs[0]) {
        videoDescs[key] = {
          filePath: _product.videoDescs[0][key].filePath,
          fileName: _product.videoDescs[0][key].fileName,
          id: _product.videoDescs[0][key].id,
          media_types: _product.videoDescs[0][key].media_types,
          media_desc: _product.videoDescs[0][key].media_desc,
          content_types: _product.videoDescs[0][key].content_types,
          language_code: _product.videoDescs[0][key].language_code,
          language_name: _product.videoDescs[0][key].language_name,
        };
      }
      const _sub_sub_category = _product.product?.subsubcategories?.find(
        (item) => item.id == _product.product.id_sub_sub_category
      );

      setState({
        ...state,
        is_creation_approved: _product.product.is_creation_approved,
        countryCode: _product.product.country_code,
        itemCode: _product.product.item_code,
        subsubcategories:
          _product?.product?.subsubcategories?.length > 0
            ? _product.product.subsubcategories
            : [],
        pseries:
          _product.product.pseries.length > 0
            ? _product.product.pseries
            : _pseries,
        iotseries: _iotseries,
        countryChange: _product.product.country_code,
        next_step_nik: _product.product.next_step_nik || null,
        next_step_name: _product.product.next_step_name || null,
        incident_id: _product.product.incident_id || null,
        incident_status: _product.product.incident_status || null,
        next_step_nik_detail: _product.product.next_step_nik_detail || null,
        next_step_name_detail: _product.product.next_step_name_detail || null,
        incident_id_detail: _product.product.incident_id_detail || null,
        incident_status_detail: _product.product.incident_status_detail || null,
        video_types: _video_types,
        media_types: _media_types,
        content_types: _content_types,
        languages: _languages,
        product: _product.product,
        files: _product.files,
        filesNew: _product.filesNew,
        filesUps: _product.filesUps ? _product.filesUps : [],
        productUps: _product.productUps
          ? _product.productUps
          : [
            {
              name: "",
              media_code: "",
              media_type: [],
              media_desc: "",
              content_type: [],
              file_path: "",
              tags: [],
            },
          ],
        filesDescs: filesDescs,
        filesDescsNew: filesDescsNew,
        fileSelectedNew: _product.fileSelectedNew,
        filesDescsUps: filesDescsUps,
        filesDescsUpss: filesDescsUps,
        videoDescs: videoDescs,
        productDetails: _product.productDetails,
        productDetail:
          _product.productDetails.length > 0
            ? _product.productDetails[0]
            : {
              language_code: "",
              language_name: "",
              title: "",
              header_description: "",
              description: "",
              feature: "",
              including: "",
              tagline: "",
              price: 0,
              manual_book: null,
              is_preorder: 0,
              is_rental: 0,
              is_active: true,
              is_publish_web: false,
              is_me_by_modena: 0,
              sku_me_by_modena: "",
              sticker_price: 0,
              seo_title: "",
              seo_description: "",
              url_ar: "",
            },
        productHighlights: _product.productHighlights,
        reqFeature: _product.feature_type ? _product.feature_type : [],
        totScoreFeature: _product.totScoreFeature,
        activeTab: _product.productDetails.length > 0 ? "tab1" : "",
        productEcom: _product.productEcom
          ? _product.productEcom
          : [{ id_store: "", url: "", price: "", line_num: 0 }],
        sub_sub_category: _sub_sub_category,
        org_id_sub_sub_category: _product.product.id_sub_sub_category,
        product_class: _product.product.product_class,
      });

      setValue("id_segment", _product.product.id_segment);
      setValue("id_category", _product.product.id_category);
      setValue("id_sub_category", _product.product.id_sub_category);
      setValue("id_sub_sub_category", _product.product.id_sub_sub_category);
      setValue("id_brand", _product.product.id_brand);
      setValue("height", _product.product.height);
      setValue("width", _product.product.width);
      setValue("weight", _product.product.weight);
      setValue("weight_type", _product.product.weight_type);
      setValue("length", _product.product.length);
      setValue("depth", _product.product.depth);
      setValue("volume", _product.product.volume);
      setValue("thickness", _product.product.thickness);
      setValue("outer_height", _product.product.outer_height);
      setValue("outer_width", _product.product.outer_width);
      setValue("outer_depth", _product.product.outer_depth);
      setValue("outer_weight", _product.product.outer_weight);
      setValue("outer_length", _product.product.outer_length);
      setValue("cut_out_height", _product.product.cut_out_height);
      setValue("cut_out_width", _product.product.cut_out_width);
      setValue("cut_out_length", _product.product.cut_out_length);
      setValue("cut_out_depth", _product.product.cut_out_depth);
      setValue(
        "cut_out_height_topmount",
        _product.product.cut_out_height_topmount
      );
      setValue(
        "cut_out_width_topmount",
        _product.product.cut_out_width_topmount
      );
      setValue(
        "cut_out_length_topmount",
        _product.product.cut_out_length_topmount
      );
      setValue(
        "cut_out_height_undermount",
        _product.product.cut_out_height_undermount
      );
      setValue(
        "cut_out_width_undermount",
        _product.product.cut_out_width_undermount
      );
      setValue(
        "cut_out_length_undermount",
        _product.product.cut_out_length_undermount
      );
      setValue("model_code", _product.product.model_code);
      setValue("item_name", _product.product.item_name);
      setValue("group_code", _product.product.group_code);
      setValue("scale", _product.product.scale);
      setValue("cardcode", _product.product.cardcode);
      setValue("launch_date", _product.product.launch_date);
      setValue("barcode_sni", _product.product.barcode_sni);
      setValue("barcode_qr", _product.product.barcode_qr);
      setValue("is_active", _product.product.is_active);
      setValue("is_publish_web", _product.product.is_publish_web);
      setValue("is_manage_serial", _product.product.is_manage_serial);
      setValue("product_class", _product.product.product_class);
      setValue("item_code_original", _product.product.item_code_original);
      setValue("id_series", _product.product.id_series);
      setValue("code_iot_series", _product.product.code_iot_series);

      setTimeout(() => {
        genBarcode(null, _product.product.barcode_sni);
        genQRCode(null, _product.product.barcode_qr);
      }, 150);
      // genModelCode(_product.product);
    });
    $("#launch_date").datetimepicker({
      format: "YYYY-MM-DD",
    });
  }, []);

  const genBarcode = (e, value) => {
    try {
      bwipjs.toCanvas("barcode", {
        bcid: "code128",
        text: value || e.target.value,
        scale: 2,
        height: 5,
        includetext: true,
        textxalign: "center",
      });
    } catch (e) { }
  };

  const genQRCode = (e, value) => {
    try {
      bwipjs.toCanvas("qrcode", {
        bcid: "qrcode",
        text: value || e.target.value,
        scale: 3,
        height: 15,
        includetext: false,
        textxalign: "center",
      });
    } catch (e) { }
  };

  const onBack = () => {
    navigate(-1);
  };

  const onCloseModal = () => {
    setTimeout(() => {
      $(modalId).modal("hide");
    }, 150);
  };

  const onCloseModal2 = () => {
    setTimeout(() => {
      $(modalId2).modal("hide");
    }, 150);
  };

  const onCloseModal3 = () => {
    setTimeout(() => {
      $(modalId3).modal("hide");
    }, 150);
  };

  const onCloseModal4 = () => {
    setTimeout(() => {
      $(modalId10).modal("hide");
    }, 150);
  };

  // const onChangeFormFeature = (feature,i,e) => {
  //     if (e.target[e.target.selectedIndex].id >= 0 && e.target.value != '') {
  //       const _reqFeature = [...reqFeature];
  //       const indexFeature = e.target[e.target.selectedIndex].id;

  //       _reqFeature[i].score = feature[indexFeature].score;
  //       _reqFeature[i].id_feature_type = feature[indexFeature].id;

  //       const _totScoreFeature = _reqFeature.reduce(
  //         (previousValue, currentValue) => {
  //         return previousValue + currentValue.score;
  //       }, 0);

  //       if (_totScoreFeature >= 30) {
  //         const product_class = 'BEST';
  //         setValue('product_class', product_class);
  //       }else if(_totScoreFeature >= 20 && _totScoreFeature <= 29 ){
  //         const product_class = 'BETTER';
  //         setValue('product_class', product_class);
  //       }else if(_totScoreFeature < 20){
  //         const product_class = 'GOOD';
  //         setValue('product_class', product_class);
  //       }else if(_totScoreFeature == 0){
  //         const product_class = '';
  //         setValue('product_class', product_class);
  //       }

  //       setState({ ...state, reqFeature: _reqFeature, totScoreFeature: _totScoreFeature});
  //     }else{
  //       const _reqFeature = [...reqFeature];

  //       _reqFeature[i].score = 0;
  //       _reqFeature[i].id_feature_type = null;

  //       const _totScoreFeature = _reqFeature.reduce(
  //         (previousValue, currentValue) => {
  //         return previousValue + currentValue.score;
  //       }, 0);

  //       if (_totScoreFeature >= 30) {
  //         const product_class = 'BEST';
  //         setValue('product_class', product_class);
  //       }else if(_totScoreFeature >= 20 && _totScoreFeature <= 29 ){
  //         const product_class = 'BETTER';
  //         setValue('product_class', product_class);
  //       }else if(_totScoreFeature < 20){
  //         const product_class = 'GOOD';
  //         setValue('product_class', product_class);
  //       }else if(_totScoreFeature == 0){
  //         const product_class = '';
  //         setValue('product_class', product_class);
  //       }

  //       setState({ ...state, reqFeature: _reqFeature, totScoreFeature: _totScoreFeature});
  //     }
  // }

  const onSaveFeature = (reqF, totScore, productClass) => {
    if (totScore < reqF.length) {
      toastError("Please complete score feature type!");
      return;
    } else {
      const _feature_type = [...reqF];

      _feature_type.map((item, i) => {
        item.own = true;
      });

      setState((prev) => {
        return {
          ...prev,
          reqFeature: reqF,
          totScoreFeature: totScore,
          feature_update: _feature_type,
          product_class: productClass,
        };
      });
      setTimeout(() => {
        setValue("product_class", productClass);
        $(modalId10).modal("hide");
      }, 150);
    }
  };

  const countDimension = (e) => {
    if (e.target.value != "" && !isNaN(e.target.value)) {
      let height =
        e.target.id == "height"
          ? parseFloat(e.target.value)
          : parseFloat(control._formValues.height);
      let width =
        e.target.id == "width"
          ? parseFloat(e.target.value)
          : parseFloat(control._formValues.width);
      let length = parseFloat(control._formValues.length);
      let depth = parseFloat(control._formValues.depth);

      if (e.target.id == "length" && (depth <= 0 || depth == "")) {
        length = parseFloat(e.target.value);
        setValue("length", length);
        if (length == 0) {
          setValue("outer_length", 0);
        }
      } else if (e.target.id == "length") {
        length = 0;
        setValue("length", 0);
        setValue("outer_length", 0);
      }

      if (e.target.id == "depth" && (length <= 0 || length == "")) {
        depth = parseFloat(e.target.value);
        setValue("depth", depth);
        if (depth == 0) {
          setValue("outer_depth", 0);
        }
      } else if (e.target.id == "depth") {
        depth = 0;
        setValue("depth", 0);
        setValue("outer_depth", 0);
      }

      if (e.target.id == "outer_length" && (length <= 0 || length == "")) {
        setValue("outer_length", 0);
      }

      if (e.target.id == "outer_depth" && (depth <= 0 || depth == "")) {
        setValue("outer_depth", 0);
      }

      if (height && width && length > 0) {
        setValue(
          "volume",
          ((length / 10) * (width / 10) * (height / 10)).toFixed(4)
        );
      } else if (height && width && depth > 0) {
        setValue(
          "volume",
          ((depth / 10) * (width / 10) * (depth / 10)).toFixed(4)
        );
      }
    } else {
      setValue(e.target.id, "");
    }
  };

  const {
    files,
    filesDescs,
    fileSelected,
    video_types,
    media_types,
    content_types,
    product,
    countryChange,
    productDetails,
    deletedFile,
    processing,
    deletedDetail,
    videoUrl,
    videoLang,
    videoSelected,
    videoDescs,
    languages,
    deletedVideo,
    selectedSupplierCode,
    suppliers,
    productDetail,
    canvasUrl,
    countryCode,
    itemCode,
    manualBooks,
    manualBooksDelete,
    filesNew,
    fileSelectedNew,
    filesDescsNew,
    deletedFileNew,
    deletedHighlight,
    deletedUps,
    deletedUpsTag,
    deletedEcom,
    productHighlights,
    productHighlight,
    deletedFileUps,
    filesUps,
    fileSelectedUps,
    productEcom,
    filesDescsUps,
    productUps,
    productUpss,
    subsubcategories,
    pseries,
    iotseries,
    feature_update,
    reqFeature,
    totScoreFeature,
    sub_sub_category,
    org_id_sub_sub_category,
  } = state;

  const propsDetailPage = { countryChange, state, setState };

  const propsModalImageDesc = {
    modalId,
    onCloseModal,
    filesDescs,
    fileSelected,
    media_types,
    content_types,
    onAddFileDescModal,
    onDescChange,
  };
  const propsModalFormVideo = {
    modalId2,
    onCloseModal2,
    Common,
    videoUrl,
    onFormVideoChange,
    onSaveVideo,
    languages,
    videoLang,
    videoDescs,
  };
  const propsModalVideoDesc = {
    modalId3,
    onCloseModal3,
    videoDescs,
    videoSelected,
    video_types,
    content_types,
    onAddVideoDescModal,
  };
  const propsModalProductFeature = {
    sub_sub_category,
    modalId10,
    onCloseModal4,
    reqFeature,
    totScoreFeature,
    onAddFeatureModal,
    onSaveFeature,
  };

  const propsProductImage = {
    files,
    filesDescs,
    register,
    errors,
    wrapStyle,
    onRemoveFile,
    onFileChange,
    onAddFileDesc,
    countDimension,
  };
  const propsProductVideo = {
    videoDescs,
    onFormVideo,
    onAddVideoDesc,
    onRemoveVideo,
  };

  useEffect(() => {
    if (selectedSupplierCode != "" && selectedSupplierCode.length >= 4) {
      const timeOut = setTimeout(() => {
        getSeupplier(selectedSupplierCode, { perpage: 10 }, ({ data }) => {
          setState({ ...state, suppliers: data.data });
        });
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedSupplierCode]);

  useEffect(() => {
    // console.log('productDetails', productDetails);
    // console.log('countryCode', countryCode);
    const _canvasUrl = [];
    productDetails.map((item) => {
      if (item.language_code) {
        let code = item.language_code.toUpperCase();
        if (countryCode !== "id") {
          code = item.language_code.toUpperCase();
          if (countryCode === "ae") {
            code = "UAE";
          }
        }
        const url = `${process.env.REACT_APP_O2O}${code}/${itemCode}`;
        _canvasUrl.push({
          id: `qr-${item.item_code}-${item.language_code}`,
          value: url,
        });
      }
    });

    setState({ ...state, canvasUrl: _canvasUrl });
  }, [productDetails]);

  useEffect(() => {
    for (const key in canvasUrl) {
      bwipjs.toCanvas(canvasUrl[key].id, {
        bcid: "qrcode",
        text: canvasUrl[key].value,
        scale: 3,
        height: 15,
        includetext: false,
        textxalign: "center",
      });
    }
  }, [canvasUrl]);

  const renderApprovalStatus = (status) => {
    if (status == "REJECTED") return "red";
    else if (status == "ONPROGRESS" || status == "ONREVISED") return "#66D3FA";
    else if (status == "COMPLETED" || status == null) return "#8CC152";
    else return "blue";
  };

  const displayApprovalStatus = (
    status,
    detail_status = undefined,
    is_creation_approved = undefined
  ) => {
    if (
      (status == "COMPLETED" || status == "NOT SUBMITTED" || status == null) &&
      is_creation_approved == true &&
      detail_status != "COMPLETED"
    )
      return "VALIDATED";
    else return status;
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <ModalFormFeature
            {...propsModalProductFeature}
            disableAll={state?.incident_status == "ONPROGRESS"}
          />
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Edit Product</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/product">Product</NavLink>
                </li>
                <li className="breadcrumb-item active">Edit Product</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />
                <form
                  className="form-edit-product"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="card-header">
                    <div className="card-title">
                      <i className="fa fa-edit" /> Edit Product{" "}
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="d-flex"
                      style={{ justifyContent: "space-evenly" }}
                    >
                      <SkuEdit product={product} />
                    </div>

                    <div className="dropdown-divider" />

                    <div className="row mb-2">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Subcategory Prefix</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={
                              (product &&
                                product.item_code_array &&
                                `${product.item_code_array[0]}${product.item_code_array[1]}`) ||
                              ""
                            }
                          />
                        </div>

                        <div className="form-group">
                          <label>Brand</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.brand_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Segment</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.segment_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Category</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.category_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Subcategory</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.sub_category_name) || ""}
                          />
                        </div>

                        {subsubcategories && (
                          <div className="form-group">
                            <label>Sub - Subcategory</label>
                            <select
                              disabled={state?.incident_status == "ONPROGRESS"}
                              id="id_sub_sub_category"
                              className="form-control"
                              {...register("id_sub_sub_category", {
                                required: {
                                  value: true,
                                  message: "Sub - Subcategory is required!",
                                },
                                onChange: onSubSubChange,
                              })}
                            >
                              {subsubcategories?.map((item, i) => (
                                <option key={`sub-subctg-` + i} value={item.id}>
                                  {item.sub_sub_category_name}
                                </option>
                              ))}
                            </select>
                            {errors.id_sub_sub_category && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.id_sub_sub_category.message}
                              </span>
                            )}
                          </div>
                        )}

                        {pseries && (
                          <div className="form-group">
                            <label>Product Series</label>
                            <select
                              disabled={state?.incident_status == "ONPROGRESS"}
                              id="id_series"
                              className="form-control"
                              {...register("id_series", {
                                required: {
                                  value: true,
                                  message: "Series is required!",
                                },
                              })}
                            >
                              <option value={""}>Select Series</option>
                              {pseries?.map((item, i) => (
                                <option key={`series-` + i} value={item.id}>
                                  {item.series_name}
                                </option>
                              ))}
                            </select>
                            {errors.id_series && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.id_series.message}
                              </span>
                            )}
                          </div>
                        )}

                        {iotseries && (
                          <div className="form-group">
                            <label>IoT Series</label>
                            <select
                              id="code_iot_series"
                              className="form-control"
                              disabled={true}
                              {...register("code_iot_series")}
                            >
                              <option value={""}>Select IoT Series</option>
                              {iotseries?.map((item, i) => (
                                <option
                                  key={`iot-series-` + i}
                                  value={item.series_code}
                                >
                                  {item.series_name}
                                </option>
                              ))}
                            </select>
                            {errors.code_iot_series && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.code_iot_series.message}
                              </span>
                            )}
                          </div>
                        )}

                        <div className="row">
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="is_active">Active</label>
                              <div>
                                <Controller
                                  disabled={
                                    state?.incident_status == "ONPROGRESS"
                                  }
                                  name="is_active"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="is_publish_web">
                                Publish Web
                              </label>
                              <div>
                                <Controller
                                  disabled={
                                    state?.incident_status == "ONPROGRESS"
                                  }
                                  name="is_publish_web"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="is_manage_serial">
                                Manage Serial Number
                              </label>
                              <div>
                                <Controller
                                  disabled={
                                    state?.incident_status == "ONPROGRESS"
                                  }
                                  name="is_manage_serial"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Color</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.color_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Country</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.country_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Certificate</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.certificate_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Electrical Rating</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.erating_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label>Assembly</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={
                              product && product.assembly
                                ? product.assembly.split("-")[1]
                                : ""
                            }
                          />
                        </div>

                        <div className="form-group">
                          <label>Original Item (SKU)</label>
                          <input
                            disabled={state?.incident_status == "ONPROGRESS"}
                            id="item_code_original"
                            {...register("item_code_original")}
                            placeholder="Item Original"
                            className="form-control"
                          />
                          {errors.item_code_original && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.item_code_original.message}
                            </span>
                          )}
                        </div>

                        <div className="d-flex justify-content-between">
                          <div className="form-group col-sm-8 mr-3">
                            <label htmlFor="product_class">Product Class</label>
                            <input
                              id="product_class"
                              {...register("product_class")}
                              placeholder=""
                              className="form-control"
                              readOnly={true}
                            />
                            {errors.product_class && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.product_class.message}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-4" style={{ marginTop: 32 }}>
                            <button
                              type="button"
                              className="btn btn-warning"
                              onClick={() => onAddFeatureModal(reqFeature)}
                              disabled={reqFeature.length == 0}
                            >
                              {" "}
                              Manage{" "}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Part Change Sequence</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={
                              (product &&
                                product.item_code_array &&
                                product.item_code_array[16]) ||
                              ""
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label>Part Change Location</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.parts_change_name) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="unit">Unit</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={(product && product.unit) || ""}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="series">Series</label>
                          <input
                            readOnly={true}
                            className="form-control"
                            value={
                              product && product.series
                                ? product.series.toUpperCase()
                                : ""
                            }
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="scale">Scale</label>
                          <input
                            disabled={state?.incident_status == "ONPROGRESS"}
                            id="scale"
                            {...register("scale", {
                              required: {
                                value: true,
                                message: "Scale is required!",
                              },
                            })}
                            placeholder="Scale"
                            className="form-control"
                          />
                          {errors.scale && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.scale.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="scale">Barcode EAN-13</label>
                          <div className="text-center">
                            <input
                              disabled={state?.incident_status == "ONPROGRESS"}
                              id="barcode_sni"
                              {...register("barcode_sni", {
                                required: {
                                  value: true,
                                  message: "Barcode EAN-13 is required!",
                                },
                                onChange: genBarcode,
                              })}
                              placeholder="Barcode EAN-13"
                              className="form-control"
                            />
                            {errors.barcode_sni && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.barcode_sni.message}
                              </span>
                            )}
                            <div
                              className="w-100 scroll mt-2"
                              style={
                                darkMode
                                  ? {
                                    overflow: "auto",
                                    overflowX: "scroll",
                                    height: 70,
                                    background: "#ccc",
                                  }
                                  : {
                                    overflow: "auto",
                                    overflowX: "scroll",
                                    height: 70,
                                  }
                              }
                            >
                              <canvas className="mt-2" id="barcode"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="model_name">Model Code</label>
                          <input
                            id="model_code"
                            {...register("model_code", {
                              required: {
                                value: true,
                                message: "Model Code is required!",
                              },
                            })}
                            placeholder="Model Code"
                            className="form-control"
                            readOnly={false}
                            disabled={state?.incident_status == "ONPROGRESS"}
                          />
                          {errors.model_code && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.model_code.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="item_name">Item Name</label>
                          <input
                            id="item_name"
                            {...register("item_name", {
                              required: {
                                value: true,
                                message: "Item Name is required!",
                              },
                            })}
                            placeholder="Item Name"
                            className="form-control"
                            disabled={state?.incident_status == "ONPROGRESS"}
                          />
                          {errors.item_name && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.item_name.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Group</label>
                          <select
                            disabled={state?.incident_status == "ONPROGRESS"}
                            id="group_code"
                            className="form-control"
                            {...register("group_code", {
                              required: {
                                value: true,
                                message: "Group Code is required!",
                              },
                            })}
                          >
                            <option value="">Select Group</option>
                            <option value="113">FG - HOME APPLIANCE</option>
                            <option value="121">FG - PROFESSIONAL</option>
                          </select>
                          {errors.group_code && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.group_code.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="cardcode">Supplier Code</label>
                          <InputAutoComplete
                            disabled={state?.incident_status == "ONPROGRESS"}
                            selectedItem={selectedSupplierCode}
                            label="CardName"
                            value="CardCode"
                            items={suppliers}
                            placeholder="Type min: 4 char of supplier name"
                            onItemClick={onClickSupplier}
                            register={{
                              ...register("cardcode", {
                                required: {
                                  value: true,
                                  message: "Cardcode is required!",
                                },
                                onChange: onSetSupplierCode,
                              }),
                            }}
                          />
                          {errors.cardcode && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.cardcode.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Launch Date</label>
                          <div
                            className="input-group date"
                            id="launch_date"
                            data-target-input="nearest"
                          >
                            <input
                              disabled={state?.incident_status == "ONPROGRESS"}
                              {...register("launch_date")}
                              type="text"
                              className="form-control datetimepicker-input"
                              data-target="#launch_date"
                              data-toggle="datetimepicker"
                            />
                          </div>
                          {errors.launch_date && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.launch_date.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Serial Number</label>
                          <div className="text-center">
                            <input
                              id="barcode_qr"
                              disabled={state?.incident_status == "ONPROGRESS"}
                              {...register("barcode_qr", {
                                required: {
                                  value: false,
                                  message: "Serial Number is required!",
                                },
                                onChange: genQRCode,
                              })}
                              placeholder="Serial Number"
                              className="form-control"
                            />
                            {errors.barcode_qr && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.barcode_qr.message}
                              </span>
                            )}
                            <div
                              className="w-100 mt-2"
                              style={
                                darkMode
                                  ? { height: 140, background: "#ccc" }
                                  : { height: 140 }
                              }
                            >
                              <canvas className="mt-2" id="qrcode"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ProductDimension
                      register={register}
                      errors={errors}
                      countDimension={countDimension}
                      disabled={state?.incident_status == "ONPROGRESS"}
                    />

                    <div className="dropdown-divider" />
                    <div className="row">
                      {productDetails.map((item, i) => {
                        if (item.language_code) {
                          const index = canvasUrl.findIndex(
                            (e) =>
                              e.id ==
                              `qr-${item.item_code}-${item.language_code}`
                          );
                          return (
                            <div className="col-md-6" key={i}>
                              <div className="card">
                                <div className="card-body">
                                  <p>
                                    <b>O2O URL</b>
                                  </p>
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <div>
                                      <canvas
                                        style={{ height: 120, width: 120 }}
                                        key={i}
                                        className="mt-2"
                                        id={`qr-${item.item_code}-${item.language_code}`}
                                      ></canvas>
                                    </div>

                                    <div className="ml-2">
                                      <span>
                                        <b>Language</b>
                                      </span>
                                      <p>{item.language_name}</p>
                                      <span>
                                        <b>URL</b>
                                      </span>
                                      <p>{canvasUrl[index]?.value}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                  <div className="card-footer">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          columnGap: "20px",
                        }}
                      >
                        <div>
                          Approval Status:
                          <span
                            style={{
                              color: renderApprovalStatus(
                                state.incident_status
                              ),
                            }}
                          >
                            &nbsp;
                            <b>
                              {state.incident_status ||
                                state.incident_status == null
                                ? displayApprovalStatus(
                                  state.incident_status,
                                  state.incident_status_detail,
                                  state.is_creation_approved
                                )
                                : "NOT SUBMITTED"}
                            </b>
                          </span>
                        </div>
                        <div>
                          {state?.next_step_nik == userInfo.nik && (
                            <div
                              className="d-flex"
                              style={{ columnGap: "15px" }}
                            >
                              {state?.incident_status == "ONPROGRESS" && (
                                <button
                                  disabled={processing}
                                  className="btn btn-success"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let code = APPROVE;
                                    onApprovalAction(code, product);
                                  }}
                                >
                                  <i className="fa fa-check" /> Approve
                                </button>
                              )}
                              {state?.incident_status != "ONPROGRESS" && (
                                <button
                                  disabled={processing}
                                  className="btn btn-primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let code = undefined;
                                    if (state?.incident_status == "ONPROGRESS")
                                      code = REVISE;
                                    else if (
                                      state?.incident_status == "ONREVISED"
                                    )
                                      code = APPROVE;
                                    onApprovalAction(code, product);
                                  }}
                                >
                                  <i className="fa fa-edit" /> Revise
                                </button>
                              )}
                              {state?.incident_status == "ONPROGRESS" && (
                                <button
                                  disabled={processing}
                                  className="btn btn-danger"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let code = REJECT;
                                    onApprovalAction(code, product);
                                  }}
                                >
                                  <i className="fa fa-times" /> Reject
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <div
                          className="d-flex"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <button
                            type="button"
                            className="btn btn-warning mr-3"
                            style={{ width: 100 }}
                            onClick={onBack}
                          >
                            <i className="fa fa-reply" /> Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            style={{ width: 100 }}
                            disabled={
                              !userInfo.access.master_product?.can_update ||
                              state?.product?.incident_status == "ONPROGRESS" ||
                              state?.product?.incident_status == "ONREVISED"
                            }
                          >
                            <i className="fa fa-save" /> Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetailEditPage;
